import { Link, useParams } from '@tanstack/react-router';
import { Button } from '@tempo-io/sui-button';
import { Effectors } from '@tempo-io/sui-icons';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrgName } from '@/lib/hooks/common/useOrgName';

interface LoopNoItemsStateProps {
  description?: string;
  additionalAction?: ReactNode;
}

export const LoopNoItemsState = ({ description, additionalAction }: LoopNoItemsStateProps) => {
  const { t } = useTranslation();
  const org = useOrgName();
  const { loopId } = useParams({ strict: false });

  return (
    <div className="flex flex-col w-full items-center gap-4 py-8">
      <div className="text-xl font-bold">
        {t(($) => $.views.visualization.emptyStates.noItems.title)}
      </div>
      {description && <div className="mb-2 text-text-neutral-secondary">{description}</div>}
      <div className="flex items-center gap-3 my-2">
        {loopId !== undefined ? (
          <Button asChild className="w-60">
            <Link to="/org/$org/loop/$loopId/integrations" params={{ org, loopId }}>
              <Effectors /> {t(($) => $.itemTable.emptyState.button)}
            </Link>
          </Button>
        ) : (
          <Button className="w-60" disabled>
            <Effectors /> {t(($) => $.itemTable.emptyState.button)}
          </Button>
        )}
        {additionalAction && (
          <>
            <span className="text-text-neutral-secondary text-sm">{t(($) => $.common.or)}</span>
            {additionalAction}
          </>
        )}
      </div>
      <div className="mt-4 text-base">
        {t(($) => $.itemTable.emptyState.help)}{' '}
        <a
          href="https://help.tempo.io"
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-info"
        >
          {t(($) => $.itemTable.emptyState.guide)}
        </a>{' '}
        {t(($) => $.itemTable.emptyState.helpSuffix)}
      </div>
    </div>
  );
};
